module.exports = __webpack_public_path__ + "static/media/icon-reset.58eb73dd.svg";